/**
 * The catalog's definitions, as numbers. They are part of the schema:
 * changing one changes what an event means, so it is a `SCHEMA_VERSION`
 * bump (`envelope.ts`), and figures on either side of it are not comparable
 * without care. Table in `improvements/23-appendix-event-catalog.md`.
 */

/** No recorded event for this long starts a new `session_id`. */
export const SESSION_TIMEOUT_MS = 30 * 60 * 1000;

/** No scroll, pointer or key input for this long pauses the engaged clock. */
export const IDLE_TIMEOUT_MS = 30 * 1000;

/** `article_complete`: scroll depth reached, and engaged time spent. */
export const ARTICLE_COMPLETE_DEPTH = 0.9;
export const ARTICLE_COMPLETE_DWELL_MS = 10 * 1000;

/**
 * `max_scroll_depth` of an article that fits the screen, so has nothing to
 * scroll: 1 once the reader has stayed this long in one stretch, 0 before.
 * Flicking past it is not reading it.
 */
export const ARTICLE_FITS_SCREEN_DWELL_MS = 1000;

/** `issue_complete`: share of pages viewed (replica) or articles opened (responsive). */
export const ISSUE_COMPLETE_REPLICA = 0.9;
export const ISSUE_COMPLETE_RESPONSIVE = 0.8;
